import React from 'react';
import { Button, Fieldset } from '@fourthwall/components';
import { FormFields } from '../../hooks/useBadgeForm/types';
export const AddCustomStyling = ({ form }) => (React.createElement(Fieldset.Row, null,
    React.createElement(Button, { label: "Add custom styling", appearance: "secondary", size: "small", onClick: () => {
            form.setFieldValue(FormFields.memberStreakBadges, form.values.memberStreakBadges.concat({
                emoji: {
                    type: 'Emoji',
                    emojiIcon: '😊',
                },
                borderColor: undefined,
                backgroundColor: 'rgba(0,0,0,0)',
                textColor: undefined,
                monthsFrom: 0,
                monthsTo: 1,
            }));
        } })));
